<template>
  <div class="vocabulary-setting-form-container">
    <div class="vocabulary-setting-form-title">
      <span>练习设定</span>
    </div>
    <!-- <div>
      <b-embed
        id="video-player"
        type="iframe"
        aspect="4by3"
        :src="'//player.bilibili.com/player.html?aid=627433254&bvid=BV1yt4y1v7KR&cid=246342113&page=1'"
        style="margin-top:-50px;"
        controls
        controlslist="nodownload"
        allowfullscreen
        autoplay
        oncontextmenu="return false;"
        crossorigin="anonymous"
      />
    </div> -->
    <div class="notify-exam text-center text-danger text-weight-bolder">{{ notifyExamText }}</div>
    <b-form>
      <b-row>
        <b-col cols="5">
          <b-row>
            <b-col>
              <b-form-group label="请选择模式">
                <b-form-radio-group
                  id="mode"
                  v-model="form.selectedMode"
                  name="mode"
                  :options="modeOptions"
                  @change="onChangeMode"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <span class="font-weight-bolder">使用说明</span>
              <p
                v-if="form.selectedMode === 'LEARNNEW'"
                class="mr-5"
              >{{ isUpgraded ? $t('Vocabulary.modeDescription.upgradedLEARNNEW') : $t('Vocabulary.modeDescription.LEARNNEW') }}</p>
              <p
                v-else-if="form.selectedMode === 'REVIEW'"
                class="mr-5"
              >{{ isUpgraded ? $t('Vocabulary.modeDescription.upgradedREVIEW') : $t('Vocabulary.modeDescription.REVIEW') }}</p>
              <p
                v-else-if="form.selectedMode === 'FORCEREVIEW'"
                class="mr-5"
              >{{ isUpgraded ? $t('Vocabulary.modeDescription.upgradedFORCEREVIEW') : $t('Vocabulary.modeDescription.FORCEREVIEW') }}</p>
              <p v-else class="mr-5">{{ $t(`Vocabulary.modeDescription.${form.selectedMode}`) }}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="7">
          <b-row>
            <b-col v-if="['LEARNNEW', 'REVIEW'].includes(form.selectedMode)">
              <b-form-group id="practiceModeFormGroup" label="一般学习模式" label-for="practiceMode">
                <b-form-radio-group
                  id="practiceMode"
                  v-model="form.selectedPracticeMode"
                  name="practiceMode"
                  :options="practiceModeOptions"
                  @change="onChangePracticeMode"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group id="selectGlossaryFormGroup" label="词库" label-for="selectGlossary">
                <b-form-select
                  id="selectGlossary"
                  v-model="form.glossary"
                  :options="glossaryList"
                  :disabled="disableGlossary"
                  @change="onChangeGlossary"
                  required
                ></b-form-select>
              </b-form-group>
              <b-row v-if="form.selectedMode === 'LEARNNEW'">
                <b-col>
                  <p v-if="learningCompleted === true" style="color: red;">此词库已学完，请到「一般复习」进行复习。</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col v-else-if="form.selectedMode === 'FORCEREVIEW'">
              <b-form-group id="practiceModeFormGroup" label="一般学习模式" label-for="practiceMode">
                <b-form-radio-group
                  id="practiceMode"
                  v-model="form.selectedPracticeMode"
                  name="practiceMode"
                  :options="practiceModeOptions"
                  @change="onChangePracticeMode"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group id="selectGlossaryFormGroup" label="词库" label-for="selectGlossary">
                <b-form-select
                  id="selectGlossary"
                  v-model="form.glossary"
                  :options="glossaryList"
                  disabled
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col v-else>
              <b-form-group id="selectExamFormGroup" label="测验卷选择" label-for="selectExam">
                <b-form-select
                  id="selectExam"
                  v-model="form.selectedExam"
                  :options="examList"
                  :disabled="disableExam"
                  @change="onChangeExam"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="!['EXAM', 'EXAMSIMULATION'].includes(form.selectedMode)">
            <b-row>
              <b-col>
                <b-form-group v-if="form.selectedMode !== 'FORCEREVIEW'" id="selectBookFormGroup" label="册" label-for="selectBook">
                  <b-form-select
                    id="selectBook"
                    v-model="form.book"
                    :options="bookList"
                    :disabled="disableBook"
                    @change="onChangeBook"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group v-if="form.selectedMode !== 'FORCEREVIEW'" id="selectLessonFormGroup" label="课" label-for="selectLesson">
                  <b-form-select
                    id="selectLesson"
                    v-model="form.lesson"
                    :options="lessonList"
                    :disabled="disableLesson"
                    :required="form.book !== null"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.selectedMode === 'LEARNNEW' || form.selectedMode === 'FORCEREVIEW'">
              <b-col>
                <p v-if="notLearnedYet && notLearnedYet.length > 0">尚未学习单字序号：{{ notLearnedYet }}</p>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <b-row>
              <b-col>
                <b-form-group
                  id="examGlossaryFormGroup"
                  :label="$t('Vocabulary.glossary')"
                  label-for="examGlossary"
                >
                  <b-form-input
                    id="examGlossary"
                    v-model="currentExam.glossary"
                    type="text"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="examRangeStartFormGroup"
                  :label="$t('Vocabulary.range')"
                  label-for="examRangeStart"
                >
                  <b-form-input
                    id="examRangeStart"
                    v-model="currentExam.range"
                    type="text"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="examModeFormGroup"
                  :label="$t('Vocabulary.examMode')"
                  label-for="examMode"
                >
                  <b-form-input id="examMode" v-model="currentExam.mode" type="text" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  id="examBookFormGroup"
                  :label="$t('Vocabulary.book')"
                  label-for="examBook"
                >
                  <b-form-input id="examBook" v-model="currentExam.book" type="text" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="examNumberOfQuestionsFormGroup"
                  :label="$t('Vocabulary.numberOfQuestions')"
                  label-for="examNumberOfQuestions"
                >
                  <b-form-input
                    id="examNumberOfQuestions"
                    v-model="currentExam.block_size"
                    type="text"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="examStartAtFormGroup"
                  :label="$t('Vocabulary.startAt')"
                  label-for="examStartAt"
                >
                  <b-form-input
                    id="examStartAt"
                    v-model="currentExam.start_at"
                    type="text"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  id="examLessonFormGroup"
                  :label="$t('Vocabulary.lesson')"
                  label-for="examLesson"
                >
                  <b-form-input id="examLesson" v-model="currentExam.lesson" type="text" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="examDurationFormGroup"
                  :label="$t('Vocabulary.examDuration')"
                  label-for="examDuration"
                >
                  <b-form-input
                    id="examDuration"
                    v-model="currentExam.durationWithUnit"
                    type="text"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="examEndAtFormGroup"
                  :label="$t('Vocabulary.endAt')"
                  label-for="examEndAt"
                >
                  <b-form-input id="examEndAt" v-model="currentExam.end_at" type="text" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.selectedMode === 'EXAM'">
              <b-col>
                <b-form-group
                  id="allowJoinTimesFormGroup"
                  :label="$t('Vocabulary.allowJoinTimes')"
                  label-for="allowJoinTimes"
                >
                  <b-form-input
                    id="allowJoinTimes"
                    v-model="currentExam.joinExamRemainTimes"
                    type="text"
                    disabled
                  ></b-form-input>
                  <b-form-invalid-feedback
                    style="font-size: 16px;"
                    :state="currentExam.joinExamRemainTimes > 0"
                  >{{ joinExamRemainTimesFeedback }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col></b-col>
              <b-col></b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group id="submitForm">
            <label for="submitForm"></label>
            <div class="vocabulary-setting-form-button">
              <b-button
                block
                id="submitForm"
                class="custom-button two"
                :disabled="disableSubmit"
                @click="submitForm"
              >下一步 ></b-button>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { MODES, PRACTICEMODE } from '../vocabularyMode'

export default {
  name: 'Basic',
  props: {
    nextStep: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      disableGlossary: true,
      disableExam: true,
      disableBook: true,
      disableLesson: true,
      disableSubmit: true,
      joinExamRemainTimesFeedback: '',
      form: {
        selectedMode: MODES.NOTEXAM[0],
        selectedPracticeMode: PRACTICEMODE.NORMAL,
        selectedExam: null,
        examCode: null,
        glossary: null,
        book: null,
        lesson: null
      },
      modeOptions: [
        { text: '学习新词汇', value: MODES.NOTEXAM[0] },
        { text: '一般复习', value: MODES.NOTEXAM[1] },
        { text: '每100字复习', value: MODES.FORCEREVIEW, disabled: true },
        { text: '模拟测验', value: MODES.EXAM[0] },
        { text: '测验', value: MODES.EXAM[1] }
      ],
      practiceModeOptions: [
        { text: '键位学习', value: PRACTICEMODE.NORMAL },
        { text: '看读学习', value: PRACTICEMODE.SKIPTYPING }
      ]
    }
  },
  mounted () {
    if (this.userGradeCode === 18) {
      this.modeOptions = this.modeOptions.map((option) => {
        if (option.value !== MODES.NOTEXAM[0]) {
          option.disabled = true
        }
        return option
      })
    }

    Promise.all([
      this.$store.dispatch('vocabularyPractice/getRules'),
      this.$store.dispatch('glossary/getGlossaries'),
      this.$store.dispatch('exam/getExams')
    ]).then(() => {
      this.disableGlossary = false
      this.disableExam = false
      this.disableBook = true
      this.disableLesson = true
      if (this.chosenMode) {
        this.form.selectedMode = this.chosenMode
        this.$store.commit('vocabularyPractice/setRule', this.chosenMode)
      }
      this.form.selectedPracticeMode = this.practiceMode
      if (this.form.selectedMode === MODES.FORCEREVIEW) {
        this.disableSubmit = false
      }
      this.$store.commit('vocabularyPractice/setMode', this.form.selectedMode)
      if (this.chosenGlossary) {
        this.form.glossary = this.chosenGlossary
        this.onChangeGlossary(this.chosenGlossary)
        if (this.chosenBook) {
          this.form.book = this.chosenBook
          this.disableBook = false
          this.onChangeBook(this.chosenBook)
          if (this.chosenLesson) {
            this.form.lesson = this.chosenLesson
            this.disableLesson = false
          }
        }
      }
      if (this.currentExam.id) {
        this.form.selectedExam = this.currentExam
      }
    })
  },
  computed: {
    ...mapState({
      isUpgraded: (state) => state.vocabularyPractice.isUpgraded,
      examList: (state) => state.exam.examList,
      currentExam: (state) => state.exam.currentExam,
      glossaryList: (state) => state.glossary.glossaryList,
      bookList: (state) => state.glossary.bookList,
      lessonList: (state) => state.glossary.lessonList,
      chosenGlossary: state => state.glossary.chosenGlossary,
      chosenBook: state => state.glossary.chosenBook,
      chosenLesson: state => state.glossary.chosenLesson,
      chosenMode: state => state.vocabularyPractice.mode,
      hasForceReview: state => state.vocabularyPractice.hasForceReview,
      userGradeCode: state => Number(state.auth.currentUser.gradeId),
      notLearnedYet: state => state.glossary.notLearnedYet,
      practiceMode: state => state.vocabularyPractice.practiceMode,
      learningCompleted: state => state.glossary.learningCompleted
    }),
    notifyExamText () {
      if (this.examList && this.examList.length > 0) {
        if (this.currentExam && this.currentExam.id !== null && this.currentExam.joinExamRemainTimes === 0) {
          return this.$t('Vocabulary.notifyCompletedExam')
        }
        if (this.examList.some((exam) => exam.available && exam.joinExamRemainTimes > 0)) {
          return this.$t('Vocabulary.notifyExam')
        }
      }
      return ''
    }
  },
  methods: {
    onChangeMode (value) {
      this.form.selectedMode = value
      this.$store.commit('vocabularyPractice/setMode', value)
      if (MODES.NOTEXAM.includes(value) && this.hasForceReview) {
        this.form.glossary = null
        this.$store.dispatch('glossary/resetNotLearnedYet')
      }
      if (value === MODES.NOTEXAM[0] && this.learningCompleted === true) {
        this.disableSubmit = true
      }
      if (value === MODES.NOTEXAM[1]) {
        this.disableSubmit = false
      }
      if (value === MODES.FORCEREVIEW) {
        this.disableSubmit = false
        this.$store.commit('vocabularyPractice/setRule', value)
      }
      if (MODES.EXAM.includes(value) && !this.form.selectedExam) {
        this.disableSubmit = true
      }
      if (value === MODES.EXAM[1] && this.currentExam && !this.currentExam.available) {
        this.disableSubmit = true
      }

      if (this.form.selectedExam === null || !this.form.selectedExam) {
        this.$store.commit('exam/resetChosenExam')
      }
      if (MODES.NOTEXAM.includes(value)) {
        this.$store.commit('vocabularyPractice/setRule', value)
      } else if (MODES.EXAM.includes(value)) {
      }
    },
    onChangeExam (value) {
      if (value) {
        this.$store
          .dispatch('exam/getExam', {
            examId: value
          })
          .then((res) => {
            if (this.currentExam.joinExamRemainTimes <= 0 || !this.currentExam.available) {
              this.joinExamRemainTimesFeedback = '已达可进入测验次数上限！'
              this.disableSubmit = true
            } else {
              this.disableSubmit = false
            }
          })
      }
    },
    onChangePracticeMode (value) {
      this.$store.commit('vocabularyPractice/setPracticeMode', value)
    },
    onChangeGlossary (value) {
      if (!this.chosenGlossary) {
        this.$store.commit('glossary/setLearningCompleted', false)
      }
      if (value === null) {
        this.disableSubmit = true
        this.modeOptions[2].disabled = true
        return
      }
      if (this.form.selectedMode === 'LEARNNEW') {
        this.$store
          .dispatch('glossary/checkIfForceReview', { glossary_id: value })
          .then((res) => {
            if (res === 'NOFORCEREVIEW') {
              this.modeOptions[2].disabled = true
              this.$store
                .dispatch('glossary/getBooksByGlossary', { glossary_id: value })
                .then((response) => {
                  if (response === 'OK') {
                    if (this.bookList.length > 0) {
                      this.form.book = this.chosenBook ? this.chosenBook : null
                      this.form.lesson = this.chosenLesson ? this.chosenLesson : null
                      this.disableBook = false
                      this.disableLesson = !this.chosenLesson
                    } else {
                      this.disableBook = true
                      this.disableLesson = !this.chosenLesson
                    }
                    this.disableSubmit = false
                  }
                })
            } else if (res === 'COMPLETE') {
              this.$store.commit('glossary/setWaitForFetching', false)
              this.modeOptions[2].disabled = true
              this.$store.commit('glossary/setLearningCompleted', true)
              this.disableSubmit = true
            } else if (this.isUpgraded && this.userGradeCode !== 18) { // 成人可选择要不要复习
              this.modeOptions[2].disabled = false
              this.$store
                .dispatch('glossary/getBooksByGlossary', { glossary_id: value })
                .then((response) => {
                  if (this.bookList.length > 0) {
                    this.form.book = this.chosenBook ? this.chosenBook : null
                    this.form.lesson = this.chosenLesson ? this.chosenLesson : null
                    this.disableBook = false
                    this.disableLesson = !this.chosenLesson
                  } else {
                    this.disableBook = true
                    this.disableLesson = !this.chosenLesson
                  }
                })
              this.disableSubmit = false
              this.$store.commit('vocabularyPractice/setHasForceReview', true)
            } else if (this.userGradeCode !== 18) { // 一班学员必须进行复习
              this.$store.commit('vocabularyPractice/setHasForceReview', true)
              this.disableSubmit = false
              this.onChangeMode('FORCEREVIEW')
              // this.form.selectedMode = MODES.FORCEREVIEW
              // this.$store.commit('vocabularyPractice/setMode', MODES.FORCEREVIEW)
            }
          })
      } else if (this.form.selectedMode === 'REVIEW') {
        this.$store
          .dispatch('glossary/getBooksByGlossary', { glossary_id: value })
          .then((response) => {
            if (response === 'OK') {
              if (this.bookList.length > 0) {
                this.form.book = this.chosenBook ? this.chosenBook : null
                this.form.lesson = this.chosenLesson ? this.chosenLesson : null
                this.disableBook = false
                this.disableLesson = !this.chosenLesson
              } else {
                this.disableBook = true
                this.disableLesson = !this.chosenLesson
              }
              this.disableSubmit = false
            }
          })
      }
    },
    onChangeBook (value) {
      if (value !== null) {
        this.$store
          .dispatch('glossary/getLessonsByBook', { book_id: value })
          .then((response) => {
            if (response === 'OK' && this.lessonList.length > 0) {
              this.form.lesson = this.chosenLesson ? this.chosenLesson : null
              this.disableLesson = false
            }
          })
      }
    },
    submitForm () {
      if (MODES.NOTEXAM.includes(this.form.selectedMode)) {
        this.$store
          .dispatch('glossary/getInitialSequenceAndBlockSize', {
            glossary: this.form.glossary,
            book: this.form.book,
            lesson: this.form.lesson
          })
          .then((res) => {
            this.nextStep()
          })
      } else if (MODES.FORCEREVIEW === this.form.selectedMode) {
        this.disableGlossary = true
        this.$store.commit('glossary/setChosenGlossary', { glossary: this.form.glossary })
        this.nextStep()
      } else if (MODES.EXAM.includes(this.form.selectedMode)) {
        this.$store.commit('glossary/setWaitForFetching', true)
        this.$store
          .dispatch('vocabularyPractice/fetchExamWords')
          .then((res) => {
            this.nextStep()
            this.$store.commit('glossary/setWaitForFetching', false)
          })
          // .catch((err) => {
          //   if (
          //     err.response.status === 400 &&
          //     err.response.data.message === 'LIMITEXCEEDED'
          //   ) {
          //     this.$store.commit('glossary/setWaitForFetching', false)
          //     this.examCodeFeedback = '已达可进入测验上限！'
          //     this.examCodeIsValid = false
          //   }
          // })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./styles/practiceSettingFormStyles.scss";
</style>
